//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/simProviderAccounts/views/main/lan/es';
import createEditSimProviderAccount from 'Modules/simProviderAccounts/views/.components/createEditSimProviderAccount/lan/es';
import deleteSimProviderAccount from 'Modules/simProviderAccounts/views/.components/deleteSimProviderAccount/lan/es';

locales = { ...locales, ...main, ...createEditSimProviderAccount, ...deleteSimProviderAccount };

export default locales;